// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main[data-v-3a6bb1e5]{overflow:initial;display:flex;min-height:100vh;min-height:100dvh;flex-direction:column;align-items:stretch}main[data-v-3a6bb1e5]{flex-grow:1;max-width:1920px;width:100%;margin:0 auto}[data-v-3a6bb1e5] .footer,[data-v-3a6bb1e5] .header,main[data-v-3a6bb1e5]{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
